/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { ISignalRService } from './signalr-service.interface';
import { ConfigurationService } from '../utils/configuration.service';
import { AuthService } from '../auth/auth.service';

export const SIGNALR_CHANNEL = 'notify';

@Injectable({
  providedIn: 'root',
})
export class SignalrService implements ISignalRService {
  public hubConnections: signalR.HubConnection[];
  public token = '';

  public channelCreated$: Subject<string>;

  constructor(
    private configurationService: ConfigurationService,
    public authService: AuthService
  ) {
    this.channelCreated$ = new Subject<string>();
  }

  public createChannel(channel: string): void {
    if (!this.hubConnections) {
      this.hubConnections = [];
    }

    if (!this.hubConnections[channel]) {
      const urlHub = this.configurationService.apiUrl;

      this.hubConnections[channel] = new signalR.HubConnectionBuilder()
        .configureLogging(signalR.LogLevel.Error)
        .withUrl(`${urlHub}/${channel}`, {
          accessTokenFactory: () => this.getToken(),
        })
        .build();

      // Add disconnect event handler
      this.hubConnections[channel].onclose(() => {
        console.log(`Connection to channel ${channel} closed.`);
        const self = this; // Capture the 'this' context
        const timeout = setTimeout(function () {
          clearTimeout(timeout); // Cancel timeout if condition is met
          self.initCommunication(channel);
        }, 3000); // Restart connection after 3 seconds.
      });

      this.hubConnections[channel].on('connectionSlow', () => {
        console.log(`Connection to channel ${channel} is slow.`);
      });
    }
    if (
      this.hubConnections[channel].state !== signalR.HubConnectionState.Connected &&
      this.hubConnections[channel].state !== signalR.HubConnectionState.Connecting
    )
      this.initCommunication(channel);
  }

  public stopCommunication(channel: string): void {
    if (this.hubConnections && this.hubConnections[channel]) {
      this.hubConnections[channel].stop();
      this.hubConnections[channel] = null;
    }
  }

  private initCommunication(channel: string): void {
    this.hubConnections[channel]
      .start()
      .then(() => {
        this.channelCreated$.next(channel);
      })
      .catch(() => this.stopCommunication(channel));
  }

  public getToken(): Promise<string> {
    return new Promise((resolve) => {
      return this.authService
        .acquireToken()
        .toPromise()
        .then((value) => resolve(value.accessToken));
    });
  }
}
